import { jsx as _jsx } from "react/jsx-runtime";
import { getTZOffsetHours } from '@iotv/datamodel-core';
import { Milliseconds } from '@iotv/iotv-v3-types';
import { useContext } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { DataGridRadioColumn } from '../../util/DataGrid/DataGridHelpers';
import { StripedDataGrid } from '../factories/DataGrid/styles/striped';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
const debug = process.env.REACT_APP_DEBUG && false;
const rowToGridRow = (item) => {
    return {
        id: item.Key ?? item.ETag ?? 'x',
        ...item,
    };
};
export const LogEntriesGrid = ({ items, loading, selectionModel, setSelectionModel }) => {
    const [{ ipData }] = useContext(AppMainViewContext);
    const tz = (ipData?.timezone ?? 'UTC');
    const columnMap = {
        Key: {
            headerName: 'Time',
            minWidth: 150,
            flex: 1,
            valueFormatter: (value) => {
                let v = value;
                if (typeof value === 'string') {
                    const prefix = value.split('/')[0];
                    const dateLikeStr = value.replaceAll(`${prefix}/`, '');
                    // this gives the format 2026/07/16/16:44:46:127. Use the following to be compatible with Firefox family
                    const utcDate = new Date(dateLikeStr.replaceAll('/', '-').replace(/(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2}):(\d{2}):(\d+)/, '$1-$2-$3 $4:$5:$6.$7'));
                    const localDate = new Date(utcDate.valueOf() + getTZOffsetHours(tz, utcDate) * Milliseconds.HOUR);
                    v = localDate.toLocaleString('en-NZ', {
                        year: '2-digit',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    });
                }
                return v;
            },
        },
    };
    const columns = [DataGridRadioColumn, ...Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v }))];
    const dataGridProps = {
        columns,
        rows: items.map(rowToGridRow),
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        loading,
        density: 'compact',
        checkboxSelection: true,
        disableColumnMenu: true,
        disableColumnResize: true,
        disableColumnSorting: true,
        disableRowSelectionOnClick: false,
        disableMultipleRowSelection: true,
        hideFooterSelectedRowCount: true,
        keepNonExistentRowsSelected: true,
        hideFooter: items.length <= 100,
        hideFooterPagination: items.length <= 100,
        rowSelectionModel: selectionModel,
        onRowSelectionModelChange: setSelectionModel,
        initialState: { pagination: { paginationModel: { pageSize: 100 } } },
    };
    debug && console.log('Customer DataGrid produced props ', dataGridProps);
    return _jsx(StripedDataGrid, { ...dataGridProps });
};
